import React, { PureComponent, Fragment } from 'react';
import { PhantomInput } from './withKeyboardClose.styles';

export default WrappedComponent => {
  return class WithKeyboardClose extends PureComponent {
    componentWillUnmount() {
      this.closeKeyboard();
    }

    phantomInputRef = React.createRef();

    closeKeyboard = () => {
      this.phantomInputRef.current.focus();
      this.phantomInputRef.current.blur();
    };

    render = () => (
      <Fragment>
        <PhantomInput ref={this.phantomInputRef} tabIndex={-1} />
        <WrappedComponent {...this.props} closeKeyboard={this.closeKeyboard} />
      </Fragment>
    );
  };
};
